<app-header class="lg:flex lg:justify-center"></app-header>
<div class="px-5 lg:mx-auto lg:flex lg:justify-center">
<app-container>

  <ng-content></ng-content>

</app-container>
<app-footer></app-footer>
</div>
